import React, { FunctionComponent } from 'react'
import numeral from 'numeral'
import { Vehicle } from '../../../core/types'
import iconOctagon from '../../../assets/images/icon-octagon.svg'

export interface Props {
  vehicle: Vehicle
}

const capitalize = (str: string) => {
  return `${str[0].toUpperCase()}${str.slice(1)}`
}

export const VehicleError: FunctionComponent<Props> = ({ vehicle }) => {
  const currentValue = (message) => {
    switch (message) {
      case 'mileage':
        return numeral(vehicle[message]).format('0,0')
      default:
        return vehicle[message]
    }
  }

  const reasons = vehicle.unrefinanceable_reasons.map((message, key) => {
    return (
      <div key={key} className="reason flex-align-vert-center">
        <h3>{capitalize(message)}</h3>
        <p>{currentValue(message)}</p>
      </div>
    )
  })

  return (
    <div>
      <div className="flex-align-vert-center">
        <img
          className="refi-app__error-icon margin-right--small margin-bottom--small"
          src={iconOctagon}
        />
        <p className="text-error">THIS CAR DOESN’T QUALIFY FOR COVERAGE</p>
      </div>
      <div className="unrefinanceable-reasons">{reasons}</div>
    </div>
  )
}

VehicleError.displayName = 'VehicleError'
